import { render } from "./topclass-section.vue?vue&type=template&id=20811266"
import script from "./topclass-section.vue?vue&type=script&lang=js"
export * from "./topclass-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__